import * as React from "react";
import { styled } from "@mui/system";
import MUIDialogContent from "@mui/material/DialogContent";
import { DialogContentProps as DialogContentPropsMUI } from "@mui/material/DialogContent";
export interface DialogContentProps extends DialogContentPropsMUI {
  component?: React.ElementType;
}

const DialogContentRoot = styled(MUIDialogContent, {
  name: "DialogContent",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiDialogContent-root": {
    padding: 24
  }
}));

export const DialogContent = React.forwardRef<
  HTMLDivElement,
  DialogContentProps
>(function DialogContent(props, ref) {
  return <DialogContentRoot {...props} ref={ref} />;
}) as React.FC<DialogContentProps>;
